import { memo } from 'components/lib/react-npm';
import { Spinner } from "components/lib/next-ui";

function CustomSpinner({ color = "default", size = "md", label = "", className = "custom-loader-primary" }) {
    return (
        <Spinner color={color} label={label} size={size} className={className} />
    )
}

export default memo(CustomSpinner)